import { Grid } from "semantic-ui-react";
import OrgSiteList from "./OrgSiteList";
import UserContext from '../../contexts/UserContext'

const Organization = () => {

    return (
        <Grid>
            <Grid.Row>
                <Grid.Column width={16} style={{overflowY: "scroll", maxHeight: "87vh"}}>
                    <OrgSiteList />
                </Grid.Column>
                {/* <Grid.Column width={16}>
                    <SiteMap sites={org?userContext.userInfo.site_list.filter(s => s.owner === org):userContext.userInfo.site_list} tickets={tickets} />
                    <BarByType sites={org?userContext.userInfo.site_list.filter(s => s.owner === org):null} tickets={tickets} />
                    <TicketsTable sites={org?userContext.userInfo.site_list.filter(s => s.owner === org):userContext.userInfo.site_list} tickets={tickets} />
                </Grid.Column> */}
            </Grid.Row>
        </Grid>
    )

}

export default Organization